import { render } from "./defaultHotspot.vue?vue&type=template&id=75434c84"
import script from "./defaultHotspot.vue?vue&type=script&lang=js"
export * from "./defaultHotspot.vue?vue&type=script&lang=js"

import "./defaultHotspot.vue?vue&type=style&index=0&id=75434c84&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__